var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.activeProfile.firstName
    ? _c("div", { staticClass: "card-group" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _vm._v(
              _vm._s(_setup.activeProfile.firstName) +
                " " +
                _vm._s(_setup.activeProfile.lastName)
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("p", { staticClass: "card-text" }, [
              _c(
                "a",
                {
                  attrs: { href: "mailto:" + _setup.activeProfile.email },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [_vm._v(_vm._s(_setup.activeProfile.email))]
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text" }, [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "tel:" +
                      (_setup.activeProfile.mobile ||
                        _setup.activeProfile.telephone),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _setup.activeProfile.mobile ||
                          _setup.activeProfile.telephone
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("Billing address"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _setup.activeProfile.billingAddress1
                ? [
                    _vm._v(_vm._s(_setup.activeProfile.billingAddress1)),
                    _c("br"),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _setup.activeProfile.billingAddress2
                ? [
                    _vm._v(_vm._s(_setup.activeProfile.billingAddress2)),
                    _c("br"),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _setup.activeProfile.billingTown
                ? [_vm._v(_vm._s(_setup.activeProfile.billingTown)), _c("br")]
                : _vm._e(),
              _vm._v(" "),
              _setup.activeProfile.billingCounty
                ? [_vm._v(_vm._s(_setup.activeProfile.billingCounty)), _c("br")]
                : _vm._e(),
              _vm._v(" "),
              _setup.activeProfile.billingPostcode
                ? [
                    _vm._v(_vm._s(_setup.activeProfile.billingPostcode)),
                    _c("br"),
                  ]
                : _vm._e(),
              _vm._v(
                "\n            " +
                  _vm._s(_setup.activeProfile.billingCountry) +
                  "\n        "
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("Delivery address"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _setup.activeProfile.address1
                ? [_vm._v(_vm._s(_setup.activeProfile.address1)), _c("br")]
                : _vm._e(),
              _vm._v(" "),
              _setup.activeProfile.address2
                ? [_vm._v(_vm._s(_setup.activeProfile.address2)), _c("br")]
                : _vm._e(),
              _vm._v(" "),
              _setup.activeProfile.townCity
                ? [_vm._v(_vm._s(_setup.activeProfile.townCity)), _c("br")]
                : _vm._e(),
              _vm._v(" "),
              _setup.activeProfile.county
                ? [_vm._v(_vm._s(_setup.activeProfile.county)), _c("br")]
                : _vm._e(),
              _vm._v(" "),
              _setup.activeProfile.postcode
                ? [_vm._v(_vm._s(_setup.activeProfile.postcode)), _c("br")]
                : _vm._e(),
              _vm._v(
                "\n            " +
                  _vm._s(_setup.activeProfile.country) +
                  "\n        "
              ),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }